export const ProfileFieldsPassword = {
  bindings: {
    form: '<',
    isUpdate: '<',
    hasError: '<',
    message: '<',
  },

  template: `
    <alert
      type="{{ $ctrl.hasError ? 'danger' : 'success' }}"
      ng-show="$ctrl.message">
      {{ $ctrl.message }}
    </alert>
    <form-group-row ng-if="$ctrl.isUpdate">
      <form-group-left>
        <form-label for="currentPassword">
          Current Password
        </form-label>
      </form-group-left>
      <form-group-right>
        <form-input
          form="$ctrl.form"
          type="password"
          name="currentPassword"
          value="$ctrl.form.data.currentPassword"
          required="true"
          errors="{ required: 'This is a required field.' }"/>
      </form-group-right>
    </form-group-row>
    <form-group-row>
      <form-group-left>
        <form-label for="password">
          <span ng-show="$ctrl.isUpdate">New</span> Password
        </form-label>
      </form-group-left>
      <form-group-right>
        <form-input
          form="$ctrl.form"
          type="password"
          name="password"
          value="$ctrl.form.data.password"
          required="true"
          minlength="6"
          errors="{
            required: 'This is a required field.',
            minlength: 'Must be at least 6 characters.',
          }"/>
      </form-group-right>
    </form-group-row>
    <form-group-row>
      <form-group-left>
        <form-label for="passwordComfirmation">
          Confirm Password
        </form-label>
      </form-group-left>
      <form-group-right>
        <input class="form-control"
          ng-class="{
            'is-valid': $ctrl.form.passwordComfirmation.$touched && $ctrl.form.passwordComfirmation.$valid,
            'is-invalid': $ctrl.form.passwordComfirmation.$touched && $ctrl.form.passwordComfirmation.$invalid
          }"
          id="password-confirmation"
          type="password"
          name="passwordComfirmation"
          match="$ctrl.form.password"
          ng-model="$ctrl.form.data.passwordConfirmation"
          ng-required="true">
        <form-errors field="$ctrl.form.passwordComfirmation" errors="{
          required: 'This is a required field.',
          match: 'Passwords must match.',
        }"/>
      </form-group-right>
    </form-group-row>`,
};



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileFieldsPassword.js